import { BrowserRouter, Routes, Route, Link, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import HomePage from "./pages/HomePage";
import AtopicForm from "./pages/AtopicForm";
import AtopicNewForm from "./pages/AtopicNewForm";
import BookingPage from "./pages/BookingPage";
import BookingSuccess from "./pages/BookingSuccess";
import BookingCancel from "./pages/BookingCancel";
import NewClientForm from "./pages/NewClientForm";
import NextSteps from "./pages/NextSteps";
import CaseStudy from "./pages/CaseStudy";
import NotabilityChecker from "./pages/NotabilityChecker";
import MeetingPage from "./pages/MeetingPage";
import WikiLogin from "./pages/wiki/WikiLogin";
import WikiPage from "./pages/wiki/WikiPage";
import WikiEdit from "./pages/wiki/WikiEdit";
import WikiHome from "./pages/wiki/WikiHome";
import WikiUpload from "./pages/wiki/WikiUpload";
import WikiTemplates from "./pages/wiki/WikiTemplates";
import WikiContributions from "./pages/wiki/WikiContributions";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminSubmissions from "./pages/admin/AdminSubmissions";
import AdminOptimize from "./pages/admin/AdminOptimize";
import "./App.css";

function AppContent() {
  const location = useLocation();
  const isWikiRoute = location.pathname.startsWith('/wiki');
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <div className={isWikiRoute || isAdminRoute ? 'wiki-theme' : 'marketing-theme'}>
      <Routes>
        {/* Marketing Routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/atopic" element={<AtopicForm />} />
        <Route path="/atopicnew" element={<AtopicNewForm />} />
        <Route path="/booking" element={<BookingPage />} />
        <Route path="/booking/success" element={<BookingSuccess />} />
        <Route path="/booking/cancel" element={<BookingCancel />} />
        <Route path="/new-client" element={<NewClientForm />} />
        <Route path="/next-steps" element={<NextSteps />} />
        <Route path="/case-study/:slug" element={<CaseStudy />} />
        <Route path="/notability" element={<NotabilityChecker />} />
        <Route path="/meeting" element={<MeetingPage />} />
        
        {/* Wiki Routes */}
        <Route path="/wiki" element={<WikiHome />} />
        <Route path="/wiki/login" element={<WikiLogin />} />
        <Route path="/wiki/upload" element={<WikiUpload />} />
        <Route path="/wiki/templates" element={<WikiTemplates />} />
        <Route path="/wiki/contributions/:username" element={<WikiContributions />} />
        <Route path="/wiki/:title" element={<WikiPage />} />
        <Route path="/wiki/:title/edit" element={<WikiEdit />} />
        
        {/* Admin Routes */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminSubmissions />} />
          <Route path="submissions" element={<AdminSubmissions />} />
          <Route path="optimize" element={<AdminOptimize />} />
        </Route>
      </Routes>
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
